import { Locale } from "@dealer-center/ddc-core-utils";
import type {
  CreateUserErrorReason,
  DeleteUserErrorReason
} from "@dealer-center/ddc-pages-configuration-interface";
import { invalidMessage, knownReason } from "../components/UserInfo";

const CREATE_ERROR_LABELS: Record<
  Exclude<CreateUserErrorReason, "INVALID">,
  string
> = {
  USER_ID_IN_USE: "UM_ADD_ERR_IN_USE",
  TIMEOUT: "UM_ADD_ERR_TIMEOUT",
  VALIDATION: "UM_ADD_ERR_GENERIC",
  UPSTREAM: "UM_ADD_ERR_GENERIC"
};

const DELETE_ERROR_LABELS: Record<DeleteUserErrorReason, string> = {
  CANNOT_DELETE: "UM_DEL_ERR_CANNOT",
  NOT_FOUND: "UM_DEL_ERR_NOT_FOUND",
  VALIDATION: "UM_DEL_ERR_GENERIC",
  UPSTREAM: "UM_DEL_ERR_GENERIC"
};

/** An `INVALID` rejection shows upstream's message as-is, like the reset. */
export const createErrorMessage = (error: unknown): string => {
  const upstreamText = invalidMessage(error);
  if (upstreamText) {
    return upstreamText;
  }

  const reason = knownReason(error, CREATE_ERROR_LABELS);

  return Locale.getText(
    reason ? CREATE_ERROR_LABELS[reason] : "UM_ADD_ERR_GENERIC"
  ) as string;
};

export const isDeleteNotFound = (error: unknown): boolean =>
  knownReason(error, DELETE_ERROR_LABELS) === "NOT_FOUND";

export const deleteErrorMessage = (error: unknown): string => {
  const reason = knownReason(error, DELETE_ERROR_LABELS);

  return Locale.getText(
    reason ? DELETE_ERROR_LABELS[reason] : "UM_DEL_ERR_GENERIC"
  ) as string;
};
